import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getReportPartnersRequest,
  addReportRequest,
  getLogEntriesRequest,
  deleteReportRequest
} from "../../api";

const initialState = {
	partners: [],
	logEntries: [],
	getPartnersInProgress: false,
	getPartnersError: null,
	getLogEntriesInProgress: false,
	getLogEntriesError: null,
	addReportInProgress: false,
	addReportError: null,
	deleteReportInProgress: false,
	deleteReportError: null

};

export const getPartners = createAsyncThunk(
  "report/getPartners",
  async (_, { rejectWithValue }) => {
	try {
	  const response = await getReportPartnersRequest();
	  return response.data;
	} catch (error) {
	  return rejectWithValue(error.message);
	}
  },
);

export const getLogEntries = createAsyncThunk(
  "report/getLogEntries",
  async (_, { rejectWithValue }) => {
	try {
	  const response = await getLogEntriesRequest();
	  return response.data;
	} catch (error) {
	  return rejectWithValue(error.message);
	}
  },
);

export const addReport = createAsyncThunk(
  "report/addReport",
  async (_, { rejectWithValue }) => {
	try {
	  const response = await addReportRequest(_);
	  return response.data;
	} catch (error) {
	  return rejectWithValue(error.message);
	}
  },
);

export const deleteReport = createAsyncThunk(
  "report/deleteReport",
  async (id, { rejectWithValue }) => {
	try {
	  const response = await deleteReportRequest(id);
	  return response.data;
	} catch (error) {
	  return rejectWithValue(error.message);
	}
  },
);


export const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
	clearData(state) {
	  state.partners = [];
	  state.logEntries = [];
	},
  },
  extraReducers: (builder) => {
	builder
	  .addCase(getPartners.pending, (state) => {
		state.getPartnersInProgress = true;
		state.getPartnersError = null;
	  })
	  .addCase(getPartners.fulfilled, (state, action) => {
		state.partners = action.payload;
		state.getPartnersInProgress = false;
		state.getPartnersError = null;
	  })
	  .addCase(getPartners.rejected, (state, action) => {
		state.getPartnersInProgress = false;
		state.getPartnersError = action.payload;
	  })
	  .addCase(addReport.pending, (state) => {
		state.addReportInProgress = true;
		state.addReportError = null;
	  })
	  .addCase(addReport.fulfilled, (state, action) => {
		state.addReportInProgress = false;
		state.addReportError = null;
	  })
	  .addCase(addReport.rejected, (state, action) => {
		state.addReportInProgress = false;
		state.addReportError = action.payload;
	  })
	  .addCase(deleteReport.pending, (state) => {
		  state.deleteReportInProgress = true;
		  state.deleteReportError = null;
		})
		.addCase(deleteReport.fulfilled, (state, action) => {
		  state.deleteReportInProgress = false;
		  state.deleteReportError = null;
		})
		.addCase(deleteReport.rejected, (state, action) => {
		  state.deleteReportInProgress = false;
		  state.deleteReportError = action.payload;
		})
	  
	  .addCase(getLogEntries.pending, (state) => {
		  state.getLogEntriesInProgress = true;
		  state.getLogEntriesError = null;
		})
		.addCase(getLogEntries.fulfilled, (state, action) => {
		state.logEntries = action.payload;
		state.getLogEntriesInProgress = false;
		state.getLogEntriesError = null;
		})
		.addCase(getLogEntries.rejected, (state, action) => {
		state.getLogEntriesInProgress = false;
		state.getLogEntriesError = action.payload;
		});
	  
  },
});

export const { clearData } = reportSlice.actions;

// this is for configureStore
export default reportSlice.reducer;
